import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/partner_1_2x.png'
import _imports_1 from '@/assets/img/partner_2_2x.png'
import _imports_2 from '@/assets/img/partner_3_2x.png'
import _imports_3 from '@/assets/img/partner_4_2x.png'
import _imports_4 from '@/assets/img/product_image.png'
import _imports_5 from '@/assets/img/logo.png'
import _imports_6 from '@/assets/img/logo_3.png'
import _imports_7 from '@/assets/img/card.png'
import _imports_8 from '@/assets/img/done.svg'


const _hoisted_1 = { class: "startSection" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mainBanner" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "bannerInfo" }
const _hoisted_7 = {
  class: "slogan font-prompt",
  style: {"font-size":"38px"}
}
const _hoisted_8 = { style: {"font-size":"18px"} }
const _hoisted_9 = {
  href: "/auth/register",
  class: "btnIconType1"
}
const _hoisted_10 = { class: "in" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("ul", { class: "partnersList" }, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_2,
      alt: "partner"
    })
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_3,
      alt: "partner"
    })
  ])
], -1)
const _hoisted_14 = { class: "right" }
const _hoisted_15 = { class: "createLinkAnimation animated" }
const _hoisted_16 = { class: "animationWrapper animated" }
const _hoisted_17 = { class: "createLinkForm animated" }
const _hoisted_18 = { class: "headBlock" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "subtitle" }
const _hoisted_21 = { class: "formBlock" }
const _hoisted_22 = { class: "fieldWrap" }
const _hoisted_23 = { class: "fieldItem" }
const _hoisted_24 = { class: "inBlockType1" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "inWrap" }
const _hoisted_27 = { class: "input" }
const _hoisted_28 = { class: "typingText product animated" }
const _hoisted_29 = { class: "fieldItem" }
const _hoisted_30 = { class: "inBlockType1" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = { class: "inWrap" }
const _hoisted_33 = { class: "input" }
const _hoisted_34 = { class: "typingText sum animated" }
const _hoisted_35 = { class: "checkWrap" }
const _hoisted_36 = { class: "checkBtn" }
const _hoisted_37 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  name: "card",
  id: "card"
}, null, -1)
const _hoisted_38 = { for: "card" }
const _hoisted_39 = { class: "btnFillType2 full" }
const _hoisted_40 = { class: "createLinkCard animated" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: "product image"
  })
], -1)
const _hoisted_42 = { class: "content" }
const _hoisted_43 = { class: "info" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "cost" }
const _hoisted_46 = { class: "button" }
const _hoisted_47 = { class: "btnIconType7" }
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "logo",
  class: "icon"
}, null, -1)
const _hoisted_49 = { class: "text" }
const _hoisted_50 = { class: "btnIconType7 dark animated" }
const _hoisted_51 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: "logo",
  class: "icon"
}, null, -1)
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "createLinkPayForm animated" }
const _hoisted_54 = { class: "paymentForm" }
const _hoisted_55 = { class: "headBlock" }
const _hoisted_56 = {
  class: "formTitle",
  style: {"font-size":"18px"}
}
const _hoisted_57 = { class: "siteLogo2" }
const _hoisted_58 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "logo"
}, null, -1)
const _hoisted_59 = { class: "data" }
const _hoisted_60 = { class: "subtitle" }
const _hoisted_61 = { class: "title" }
const _hoisted_62 = { class: "formBlock" }
const _hoisted_63 = { class: "fieldsWrap" }
const _hoisted_64 = { class: "fieldItem" }
const _hoisted_65 = { class: "col" }
const _hoisted_66 = { class: "inBlockType1" }
const _hoisted_67 = { class: "label" }
const _hoisted_68 = { class: "inWrap" }
const _hoisted_69 = { class: "input" }
const _hoisted_70 = { class: "fadingText animated" }
const _hoisted_71 = { class: "fieldItem" }
const _hoisted_72 = { class: "col" }
const _hoisted_73 = { class: "inBlockType1" }
const _hoisted_74 = { class: "label" }
const _hoisted_75 = { class: "inWrap comb" }
const _hoisted_76 = { class: "input" }
const _hoisted_77 = { class: "fadingText animated" }
const _hoisted_78 = { class: "input" }
const _hoisted_79 = { class: "fadingText animated" }
const _hoisted_80 = { class: "col" }
const _hoisted_81 = { class: "inBlockType1" }
const _hoisted_82 = { class: "label" }
const _hoisted_83 = { class: "inWrap" }
const _hoisted_84 = { class: "input" }
const _hoisted_85 = { class: "fadingText animated" }
const _hoisted_86 = { class: "btnFillType2 full upp" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "createLinkPayCard animated" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_7,
    alt: "card"
  })
], -1)
const _hoisted_88 = { class: "createLinkResult animated" }
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_8,
    alt: "done"
  })
], -1)
const _hoisted_90 = { class: "text" }
const _hoisted_91 = /*#__PURE__*/_createVNode("div", { class: "overlay" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("slogan1")), 1),
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t("slogan2")), 1),
              _createVNode("a", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t("startSection.signup")), 1),
                  _hoisted_12
                ])
              ])
            ]),
            _hoisted_13
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("span", _hoisted_19, _toDisplayString(_ctx.t("startSection.createLinkForm.title")), 1),
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t("startSection.createLinkForm.subtitle")), 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t("startSection.createLinkForm.proServiceLabel")), 1),
                          _createVNode("div", _hoisted_26, [
                            _createVNode("div", _hoisted_27, [
                              _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t("startSection.createLinkForm.proServiceValue")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.t("startSection.createLinkForm.amountLabel")), 1),
                          _createVNode("div", _hoisted_32, [
                            _createVNode("div", _hoisted_33, [
                              _createVNode("span", _hoisted_34, _toDisplayString(_ctx.t("startSection.createLinkForm.amountValue")), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode("label", _hoisted_38, _toDisplayString(_ctx.t("startSection.createLinkForm.card")), 1)
                      ])
                    ]),
                    _createVNode("span", _hoisted_39, _toDisplayString(_ctx.t("startSection.createLinkForm.submit")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode("div", _hoisted_42, [
                    _createVNode("div", _hoisted_43, [
                      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.t("startSection.createLinkCard.title")), 1),
                      _createVNode("span", _hoisted_45, _toDisplayString(_ctx.t("startSection.createLinkCard.cost")), 1)
                    ]),
                    _createVNode("div", _hoisted_46, [
                      _createVNode("button", _hoisted_47, [
                        _hoisted_48,
                        _createVNode("span", _hoisted_49, _toDisplayString(_ctx.t("startSection.createLinkCard.pay")), 1)
                      ]),
                      _createVNode("button", _hoisted_50, [
                        _hoisted_51,
                        _createVNode("span", _hoisted_52, _toDisplayString(_ctx.t("startSection.createLinkCard.pay")), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("div", _hoisted_56, _toDisplayString(_ctx.t("startSection.createLinkPayForm.checkout")), 1),
                      _createVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createVNode("div", _hoisted_59, [
                          _createVNode("span", _hoisted_60, _toDisplayString(_ctx.t("startSection.createLinkPayForm.subTitle")), 1),
                          _createVNode("span", _hoisted_61, _toDisplayString(_ctx.t("startSection.createLinkPayForm.title")), 1)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_62, [
                      _createVNode("div", _hoisted_63, [
                        _createVNode("div", _hoisted_64, [
                          _createVNode("div", _hoisted_65, [
                            _createVNode("div", _hoisted_66, [
                              _createVNode("span", _hoisted_67, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cardNoLabel")), 1),
                              _createVNode("div", _hoisted_68, [
                                _createVNode("div", _hoisted_69, [
                                  _createVNode("span", _hoisted_70, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cardNoValue")), 1)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_71, [
                          _createVNode("div", _hoisted_72, [
                            _createVNode("div", _hoisted_73, [
                              _createVNode("span", _hoisted_74, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateLabel")), 1),
                              _createVNode("div", _hoisted_75, [
                                _createVNode("div", _hoisted_76, [
                                  _createVNode("span", _hoisted_77, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateValue1")), 1)
                                ]),
                                _createVNode("div", _hoisted_78, [
                                  _createVNode("span", _hoisted_79, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateValue2")), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_80, [
                            _createVNode("div", _hoisted_81, [
                              _createVNode("span", _hoisted_82, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cvcLabel")), 1),
                              _createVNode("div", _hoisted_83, [
                                _createVNode("div", _hoisted_84, [
                                  _createVNode("span", _hoisted_85, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cvcValue")), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("button", _hoisted_86, _toDisplayString(_ctx.t("startSection.createLinkPayForm.submit")), 1)
                    ])
                  ])
                ]),
                _createVNode(_Transition, null, {
                  default: _withCtx(() => [
                    _hoisted_87
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createVNode("span", _hoisted_90, _toDisplayString(_ctx.t("startSection.createLinkPayForm.way")), 1)
                ]),
                _hoisted_91
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}